import React from 'react';
import './devpages.scss';

const DevPages = () => {
  return (
    <section className='company-propduct-wrap f-center'>
      <div className='f-container'>
        <img className="fit-picture" src='/img/under_construction.png'  alt='under_construction' />

      </div>
    </section>
  );
};


export default DevPages;



// WEBPACK FOOTER //
// ./src/client/components/devpages/devpages.jsx